const voucher = (state = "" , action) => {
    switch(action.type){
        case  'updateVoucher':
            return  action.payload;
        default :
            return state;
    }
}
export default voucher;